import { IconCheck } from '../../../icons/IconCheck';
import { DisplayHeading } from '../../../typography/DisplayHeading';

import { decodeHTMLEntities } from '../../../utils/decodeHTMLEntities';

export type WhatIsIncludedProps = {
  content: string;
  className?: string;
  dataTestId?: string;
};

export const WhatIsIncluded = ({
  className,
  content,
  dataTestId = 'what-is-included',
}: WhatIsIncludedProps) => {
  if (!content) {
    return null;
  }

  // Throw error to prevent building if there's no ul/li in the content string
  if (!content.includes('<ul>') || !content.includes('<li>')) {
    throw new Error('Missing li in whatsincluded list');
  }

  // This should be removed when API returns plain content
  //  Strip html ul
  const strippedList = content.replace(/<\/?ul>/g, '');
  //@TODO: This should use sanitize-html or any other HTML sanitizer
  // Strip html li from html string <- this should be removed once API returns plain content instead of HTML, note that playing with source is risky.
  const strippedElements = strippedList.replace(/(<([^>]+)>)/gi, '').split('\n');
  const formattedList = strippedElements
    .filter((string) => string.trim().length > 0)
    .map((string, index) => {
      return (
        <li className="mt-2 flex items-baseline leading-relaxed" key={index}>
          <div className="relative h-5 w-6 leading-relaxed">
            <IconCheck className="absolute top-1" />
          </div>
          <span className="ml-2 flex-1">{decodeHTMLEntities(string)}</span>
        </li>
      );
    });

  return (
    <div data-testid={dataTestId} className={className}>
      <DisplayHeading
        className="text-neutral-strong text-xl"
        size="3"
        as="h2"
      >{`What's Included`}</DisplayHeading>
      <ul className="text-neutral mt-4 list-none">{formattedList}</ul>
    </div>
  );
};
